import { render, staticRenderFns } from "./photo-finish.vue?vue&type=template&id=2a92420c&lang=pug&"
import script from "./photo-finish.vue?vue&type=script&lang=js&"
export * from "./photo-finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a92420c')) {
      api.createRecord('2a92420c', component.options)
    } else {
      api.reload('2a92420c', component.options)
    }
    module.hot.accept("./photo-finish.vue?vue&type=template&id=2a92420c&lang=pug&", function () {
      api.rerender('2a92420c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photos/finish/photo-finish.vue"
export default component.exports